import React, { Component } from "react";
import styled from "styled-components";
import Loader from "./Loader";

class LoadBarButton extends Component {
  render() {
    return (
      <Center>
        {this.props.loading ? (
          <Loader padding="10px" color="#00ff00" />
        ) : (
          <Button onClick={this.props.clickAction}>{this.props.text}</Button>
        )}
      </Center>
    );
  }
}

const Center = styled.div`
  display: block;
  text-align: center;
  padding: 0px;
  background: rgba(253, 186, 3, 0);
  @media only screen and (max-width: 980px) {
    padding: 0;
  }
`;

const Button = styled.button`
  margin: 0;
  padding: 10px;
  color: #000000;
  background: rgba(253, 186, 3, 0);
  font-family: "Bree Serif", serif;
  text-transform: uppercase;
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: block;
  width: 100%;
  border: none;
  box-sizing: border-box;
  outline: none;
`;

export default LoadBarButton;



// WEBPACK FOOTER //
// ./src/components/LoadBarButton.js